import { render, staticRenderFns } from "./SchoolDistrictsList.vue?vue&type=template&id=cdfdc8aa&scoped=true&"
import script from "./SchoolDistrictsList.vue?vue&type=script&lang=js&"
export * from "./SchoolDistrictsList.vue?vue&type=script&lang=js&"
import style0 from "./SchoolDistrictsList.vue?vue&type=style&index=0&id=cdfdc8aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfdc8aa",
  null
  
)

export default component.exports